import React from "react";
import {
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  TagOutlined,
  DownOutlined,
} from "@ant-design/icons";

/**
 * A tiny looping demo of composing and sending a campaign: write the
 * message, pick an audience, hit Send Now. Purely decorative CSS
 * animation (see .quick-send-demo in index.css); prefers-reduced-motion
 * shows a static mid-compose frame with the message already written
 * instead of looping.
 */
export default function QuickSendAnimation() {
  return (
    <div className="quick-send-demo" aria-hidden="true">
      <div className="qsd-toolbar">
        <BoldOutlined />
        <ItalicOutlined />
        <UnderlineOutlined />
      </div>
      <div className="qsd-textarea">
        <span className="qsd-text">
          Hi firstName, Your July Newsletter is ready.
        </span>
        <span className="qsd-cursor" />
      </div>
      <div className="qsd-dropdown">
        <span className="qsd-dropdown-placeholder">Select audience</span>
        <span className="qsd-dropdown-tag">
          <TagOutlined /> Newsletter Subscribers
        </span>
        <DownOutlined className="qsd-dropdown-chevron" />
      </div>
      <div className="qsd-actions">
        <button type="button" className="qsd-send" tabIndex={-1}>
          Send Now
        </button>
        <button type="button" className="qsd-schedule" tabIndex={-1}>
          Schedule
        </button>
        <span className="qsd-sent mk-mono">Sent</span>
      </div>
    </div>
  );
}
